/**
 * Takes a global GraphQL ID and returns the database ID
 *
 * @param globalId
 */
export function toDbId(globalId: string): number {
  return parseInt(atob(globalId).split(":")[1], 10);
}

/**
 * Takes an object type and database ID and returns a global ID
 *
 * @param objectType
 * @param dbId
 */
export function toGlobalId(objectType: string, dbId: number | string): string {
  return btoa([encodeURIComponent(objectType), dbId].join(":"));
}

export type ObjectTypeAndId = [string, number];

/**
 * Takes a global GraphQL ID and returns the string ObjectType and the int db id
 */
export function toObjectTypeAndId(globalId: string): ObjectTypeAndId {
  const [objectType, stringId] = atob(globalId).split(":");
  return [objectType, parseInt(stringId, 10)];
}

/**
 * Takes an object type and database ID and returns a federation global ID
 *
 * @param objectType
 * @param dbId
 */
export function toFederationGlobalId(objectType: string, dbId: number | string): string {
  return btoa(JSON.stringify({ type: encodeURIComponent(objectType), id: dbId }));
}
